import { Info, Pen, Trash } from "lucide-react";
import React from "react";

const SupplierItem = ( props ) => {

    var p = props.data;
    return (
        <div className="cursor-pointer border-t border-gray-100 p-3 flex justify-between items-center hover:bg-gray-50">
            <div className="item-data" onClick={( id ) => props.onClick( id )}>
                <span className="item-title text-gray-800 font-semibold"><a className="hover:underline" href={`/suppliers/view/${p.id}`}>{p.companyName}</a></span>
                <span className="item-focus text-gray-600">{p.address + ", " + p.country}</span>
            </div>
            <div className="flex gap-2 item-actions">
                {/* <button onClick={( id ) => props.onClick( id )}><Info className="text-secondary-500 hover:text-primary-500" /></button>
                <button onClick={( id ) => props.onEdit( id )}><Pen className="text-secondary-500 hover:text-primary-500" /></button> */}
                {/* <button onClick={( id ) => props.onDelete( id )}><Trash className="text-secondary-500 hover:text-primary-500" /></button> */}
            </div>
        </div>
    )
}
export default SupplierItem;